import React from 'react';
import PropTypes from 'prop-types';
import { Progress, Tooltip } from 'antd';
import {
  ItemLabelHeader,
  AlertScoreWrapper,
  ItemLabelContent
} from '../styled';
import { capitalize } from 'lodash';

const AlertScore = ({
  itemValue,
  alertLevel,
  alertLevelColor,
  alertLevelLabel,
  itemLabel,
  showValueLeft = false,
  showValueRight = true
}) => (
  <>
    <ItemLabelHeader>{itemLabel}</ItemLabelHeader>
    {itemValue || itemValue == 0 ? (
      <AlertScoreWrapper>
        {showValueLeft && (
          <Tooltip title={itemValue}>
            <p>{itemValue.toFixed(2).toString()}</p>
          </Tooltip>
        )}
        <Progress
          percent={itemValue}
          strokeColor={alertLevelColor}
          showInfo={false}
        />
        {showValueRight && (
          <Tooltip title={itemValue}>
            <p>
              <b>{`${alertLevelLabel || capitalize(alertLevel)} ${itemValue
                .toFixed(2)
                .toString()}`}</b>
              /100
            </p>
          </Tooltip>
        )}
      </AlertScoreWrapper>
    ) : (
      <ItemLabelContent>--</ItemLabelContent>
    )}
  </>
);

AlertScore.propTypes = {
  itemValue: PropTypes.number,
  alertLevel: PropTypes.string,
  itemLabel: PropTypes.string.isRequired,
  showValueLeft: PropTypes.bool,
  showValueRight: PropTypes.bool
};

export default AlertScore;
